var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCc7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 65,
    viewBox: "0 0 63 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2137_3027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.6992 58.146C50.9762 61.3758 50.2184 64.492 46.5816 64.9946L4.22299 65C2.01231 64.7856 0.193008 63.1501 0.00178528 60.8876V4.24567C0.109013 1.95081 1.98729 0.176528 4.22299 0L33.7893 0.0648469L50.4025 16.6566L50.6741 17.3285L50.7367 29.2658L62.3781 36.0278L62.9339 36.5484C63.6648 45.6522 58.4518 53.8517 50.701 58.146H50.6992ZM32.7099 1.62297H3.96028C3.91382 1.62297 3.21684 1.91298 3.10246 1.97243C2.30004 2.39213 1.65488 3.3252 1.6102 4.24567V60.7525C1.72816 62.2098 2.93447 63.2798 4.35703 63.3824H46.3207C49.1587 63.06 49.2176 60.5454 49.0657 58.2127C43.1825 54.6984 38.5985 49.5034 37.2224 42.59C37.0044 41.493 36.3932 37.2419 36.856 36.4674L49.0622 29.1955V18.0725H33.0459C33.0226 18.0725 32.7099 17.759 32.7099 17.7356V1.62297ZM47.8558 16.4549L34.3183 2.83705V16.4549H47.8558ZM49.9325 30.66L38.4073 37.3554C37.9408 45.6054 42.859 52.8232 49.8199 56.7446C55.6138 53.5707 59.9619 48.2137 61.086 41.5633C61.2164 40.7905 61.6454 37.7607 61.2575 37.2888L49.9325 30.66Z",
    fill: "#0F79E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00635 23.2224L42.1656 23.1899L42.8948 23.4007C43.4166 24.0852 42.8483 24.8688 42.0316 24.8219H8.64436C7.68288 24.8453 7.06453 23.8114 8.00635 23.2242V23.2224Z",
    fill: "#0F79E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.14218 29.5612L41.2274 29.527C42.5606 29.5108 42.5534 31.177 41.2274 31.1572H8.51033C7.37907 31.1535 7.21108 30.1052 8.14218 29.5612Z",
    fill: "#0F79E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00635 55.1775L41.9029 55.273C42.4909 55.9773 41.9815 56.8077 41.0933 56.7752H8.64436C7.68288 56.7987 7.06453 55.7647 8.00635 55.1775Z",
    fill: "#0F79E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.27801 48.7089L36.5344 48.6765C37.6442 48.6927 37.7532 50.1662 36.672 50.3049H8.24226C7.82407 50.3157 7.58281 49.9374 7.52205 49.5555C7.57566 49.1448 7.88662 48.8152 8.27801 48.7071V48.7089Z",
    fill: "#0F79E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.14397 42.3719L34.388 42.3413C35.53 42.3881 35.4245 43.8328 34.3934 43.9679L8.38166 43.9625C7.42554 43.9805 7.19143 42.5935 8.14397 42.3719Z",
    fill: "#0F79E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00636 36.0314L33.9895 35.999C35.1332 36.1485 34.6293 37.84 33.4515 37.6292H8.78019C7.76867 37.6688 6.99663 36.7249 8.00636 36.0314Z",
    fill: "#0F79E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00636 13.7836L25.9474 13.7512C27.0483 13.8935 26.8535 15.3598 25.8098 15.3796H8.5139C7.60068 15.3057 7.12351 14.3222 8.00636 13.7854V13.7836Z",
    fill: "#0F79E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00636 7.98701L25.9474 7.95459C27.1072 8.1041 26.8231 9.65322 25.6722 9.57936L8.5139 9.58297C7.60068 9.50911 7.12351 8.5238 8.00636 7.98881V7.98701Z",
    fill: "#0F79E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3034 35.7774C59.5723 35.0028 60.7893 50.7678 50.6027 51.6451C40.105 52.5493 38.9166 36.5609 49.3034 35.7774ZM49.4375 37.3931C41.1791 38.0128 42.0494 50.7372 50.4686 50.0257C58.559 49.3412 57.5868 36.7807 49.4375 37.3931Z",
    fill: "#0F79E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2556 40.4896C54.6684 40.8841 54.5058 41.4893 54.1555 41.8694L48.9371 46.9995L48.0506 46.9311C47.5681 46.2232 45.1537 44.4381 45.2448 43.6707C45.3074 43.1429 45.8221 42.8115 46.3189 43.0006C46.8479 43.2024 48.4384 45.1694 48.5957 45.1694L53.2798 40.4446C53.5085 40.2338 54.05 40.2879 54.2574 40.4878L54.2556 40.4896Z",
    fill: "#0F79E3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2137_3027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 65,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCc7);
export default __webpack_public_path__ + "static/media/cc-7.0a1ad8e4a5772234cd1804bf864aa774.svg";
export { ForwardRef as ReactComponent };